import React from "react";
import { Modal } from "../../components/modal";
import { CardPanel, Container } from "./style";
import { UserManagementAction } from "../../actions";
import { connect } from "react-redux";
import { USER_MANAGEMENT_ICON } from "../../constants/icons";
import { withRouter } from "react-router-dom";
import {
  MY_TEAM_MEMBER_MANAGEMENT,
  SHARED_PROJECTS_MANAGEMENT
} from "../../constants/urls";

const Index = props => {
  const { modalStatus, closeModal, history } = props;

  const handleOnItemClick = link => {
    history.push(link);
    closeModal();
  };
  if (modalStatus) {
    return (
      <Modal
        header={{ title: `مدیریت اعضای شرکت‌ها` }}
        show={modalStatus}
        closeHandler={closeModal}
        height={"auto"}
        body={
          <Container>
            <CardPanel
              onClick={() => {
                handleOnItemClick(MY_TEAM_MEMBER_MANAGEMENT);
              }}
            >
              <div className="top-row">
                <i className={`role-icon icon ${USER_MANAGEMENT_ICON}`} />
                <div className="panel-name">
                  مدیریت اعضای تیم در شرکت‌های خودم
                </div>
              </div>
            </CardPanel>
            <CardPanel
              onClick={() => {
                handleOnItemClick(SHARED_PROJECTS_MANAGEMENT);
              }}
            >
              <div className="top-row">
                <i className={`role-icon icon ${USER_MANAGEMENT_ICON}`} />
                <div className="panel-name">
                  مدیریت اعضای تیم در سایر شرکت‌ها
                </div>
              </div>
            </CardPanel>
          </Container>
        }
        loading={false}
      />
    );
  } else {
    return null;
  }
};

const mapStateToProps = store => {
  return {
    modalStatus: store.UserManagement.menuModalStatus
  };
};
const mapDispatchToProps = dispatch => {
  return {
    closeModal: () => {
      dispatch(UserManagementAction.closeTeamManagementMenuModal());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Index));
